function FeaturedTestimonials() {
    return (
        <div className="featured-testimonial">
            <div className="featured-testimonial__container container">
                <blockquote className="featured-testimonial__quote">
                    <p className="featured-testimonial__quote-para">
                        The Library is overall the best and most convenient deal for online reading.
                    </p>
                    <footer><cite className="featured-testimonial__quote-cite">Business Insider</cite></footer>
                </blockquote>
            </div>
        </div>
    )
}

export default FeaturedTestimonials;